/* tslint:disable */
/* eslint-disable */
/**
 * MrbilitContent
 * Content management service for mrbilit website
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: badihi.2006@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AppDeprecationsCountGet200Response } from '../model';
// @ts-ignore
import { Banner } from '../model';
// @ts-ignore
import { NewBanner } from '../model';
/**
 * BannerApiBannersCountGet - axios parameter creator
 * 
 * @summary 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BannerApiBannersCountGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/banners/count`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BannerApiBannersGet - axios parameter creator
 * 
 * @summary 
 * @param {number} [limit] Maximum number of results possible
 * @param {string} [sort] Sort according to a specific field.
 * @param {number} [start] Skip a specific number of entries (especially useful for pagination)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BannerApiBannersGetAxiosParamCreator (limit?: number, sort?: string, start?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/banners`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (limit !== undefined) {
        localVarQueryParameter['_limit'] = limit;
    }

    if (sort !== undefined) {
        localVarQueryParameter['_sort'] = sort;
    }

    if (start !== undefined) {
        localVarQueryParameter['_start'] = start;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BannerApiBannersIdDelete - axios parameter creator
 * Delete a record
 * @summary 
 * @param {string} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BannerApiBannersIdDeleteAxiosParamCreator (id: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('bannersIdDelete', 'id', id)
    const localVarPath = `/banners/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BannerApiBannersIdGet - axios parameter creator
 * 
 * @summary 
 * @param {string} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BannerApiBannersIdGetAxiosParamCreator (id: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('bannersIdGet', 'id', id)
    const localVarPath = `/banners/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BannerApiBannersIdPut - axios parameter creator
 * Update a record
 * @summary 
 * @param {string} id 
 * @param {NewBanner} newBanner 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BannerApiBannersIdPutAxiosParamCreator (id: string, newBanner: NewBanner, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('bannersIdPut', 'id', id)
    // verify required parameter 'newBanner' is not null or undefined
    assertParamExists('bannersIdPut', 'newBanner', newBanner)
    const localVarPath = `/banners/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(newBanner, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BannerApiBannersPost - axios parameter creator
 * Create a new record
 * @summary 
 * @param {NewBanner} newBanner 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BannerApiBannersPostAxiosParamCreator (newBanner: NewBanner, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'newBanner' is not null or undefined
    assertParamExists('bannersPost', 'newBanner', newBanner)
    const localVarPath = `/banners`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(newBanner, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for bannersGet operation in BannerApi.
 * @export
 * @interface BannerApiBannersGetRequest
 */
export interface BannerApiBannersGetRequest {
    /**
     * Maximum number of results possible
     * @type {number}
     * @memberof BannerApiBannersGet
     */
    readonly limit?: number

    /**
     * Sort according to a specific field.
     * @type {string}
     * @memberof BannerApiBannersGet
     */
    readonly sort?: string

    /**
     * Skip a specific number of entries (especially useful for pagination)
     * @type {number}
     * @memberof BannerApiBannersGet
     */
    readonly start?: number
}

/**
 * Request parameters for bannersIdDelete operation in BannerApi.
 * @export
 * @interface BannerApiBannersIdDeleteRequest
 */
export interface BannerApiBannersIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof BannerApiBannersIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for bannersIdGet operation in BannerApi.
 * @export
 * @interface BannerApiBannersIdGetRequest
 */
export interface BannerApiBannersIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BannerApiBannersIdGet
     */
    readonly id: string
}

/**
 * Request parameters for bannersIdPut operation in BannerApi.
 * @export
 * @interface BannerApiBannersIdPutRequest
 */
export interface BannerApiBannersIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof BannerApiBannersIdPut
     */
    readonly id: string

    /**
     * 
     * @type {NewBanner}
     * @memberof BannerApiBannersIdPut
     */
    readonly newBanner: NewBanner
}

/**
 * Request parameters for bannersPost operation in BannerApi.
 * @export
 * @interface BannerApiBannersPostRequest
 */
export interface BannerApiBannersPostRequest {
    /**
     * 
     * @type {NewBanner}
     * @memberof BannerApiBannersPost
     */
    readonly newBanner: NewBanner
}

/**
* 
* @summary 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BannerApiBannersCountGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BannerApiBannersCountGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<AppDeprecationsCountGet200Response> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary 
* @param {BannerApiBannersGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BannerApiBannersGet(requestParameters: BannerApiBannersGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BannerApiBannersGetAxiosParamCreator(requestParameters.limit, requestParameters.sort, requestParameters.start, options, configuration);
    const request: () => AxiosPromise<Array<Banner>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Delete a record
* @summary 
* @param {BannerApiBannersIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BannerApiBannersIdDelete(requestParameters: BannerApiBannersIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BannerApiBannersIdDeleteAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<number> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary 
* @param {BannerApiBannersIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BannerApiBannersIdGet(requestParameters: BannerApiBannersIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BannerApiBannersIdGetAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<Banner> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Update a record
* @summary 
* @param {BannerApiBannersIdPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BannerApiBannersIdPut(requestParameters: BannerApiBannersIdPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BannerApiBannersIdPutAxiosParamCreator(requestParameters.id, requestParameters.newBanner, options, configuration);
    const request: () => AxiosPromise<Banner> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Create a new record
* @summary 
* @param {BannerApiBannersPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BannerApiBannersPost(requestParameters: BannerApiBannersPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BannerApiBannersPostAxiosParamCreator(requestParameters.newBanner, options, configuration);
    const request: () => AxiosPromise<Banner> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
